import { render, staticRenderFns } from "./OriginShippingCard.vue?vue&type=template&id=258b9391&scoped=true&"
import script from "./OriginShippingCard.vue?vue&type=script&lang=js&"
export * from "./OriginShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./OriginShippingCard.vue?vue&type=style&index=0&id=258b9391&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b9391",
  null
  
)

export default component.exports